import React, { Suspense } from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { AnimatedPageLoader } from 'smartsuite-ui';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ErrorBoundary from './components/ErrorBoundary';

import 'smartsuite-ui/dist/smartsuite-ui.css';
import './i18n';

const ConfigurationAppWrapper = React.lazy(() =>
    import('./apps/Configuration/ConfigurationAppWrapper')
);
const DefaultRoute = React.lazy(() => import('./components/DefaultRoute'));
const WelcomePage = React.lazy(() => import('./components/WelcomePage'));

const rootElement = document.getElementById('root');

const queryClient = new QueryClient({
    defaultOptions: { queries: { refetchOnWindowFocus: false } },
});

render(
    <ErrorBoundary>
        <Suspense fallback={<AnimatedPageLoader />}>
            <Router basename={window.rootUrl}>
                <Switch>
                    <QueryClientProvider client={queryClient}>
                        <Route
                            path="/apps/Configuration"
                            component={ConfigurationAppWrapper}
                        />
                        <Route path="/apps/welcome" component={WelcomePage} />
                        <Route exact={true} path="/" component={DefaultRoute} />
                    </QueryClientProvider>
                </Switch>
            </Router>
        </Suspense>
    </ErrorBoundary>,
    rootElement
);
